import { DropdownItem } from 'app/viewmodels/dropdown-item';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { LoadingDropdownData } from '../../../viewmodels/form-controls/loading-dropdown-data';
import { LoadingDropdownSettings } from './event-emitter-entities/loading-more-settings';
import { FormControlBase } from './form-control-base';
import { FormControlData } from './form-control-data';

export class LoadingDropdownControl extends FormControlBase<any> {
  controlType = 'loading-dropdown';
  loading = false;
  loadItemsRequest = new Subject<LoadingDropdownSettings>();

  selectedItemId: string;

  constructor(options: FormControlData<any> = {}) {
    super(options);
  }

  protected initialize() {
    this.value = _.get(this.model, this.propertyName);
  }

  public commit() {
    if (this.value === '') {
      _.set(this.model, this.propertyName, undefined);
    } else {
      _.set(this.model, this.propertyName, this.value);
    }
  }

  public addOptions(data: LoadingDropdownData, settings: LoadingDropdownSettings) {
    let dropdownOptions = this.getDropdownOptions(data);
    const { selectedItem } = data;

    if (selectedItem && selectedItem.key && data.selectedItem.value && settings.startItemNumber === 0) {
      dropdownOptions = this.addSelectedItem(dropdownOptions, data.selectedItem);
      this.selectedItemId = data.selectedItem.key;
    }

    if (settings.startItemNumber === 0) {
      this.options = dropdownOptions;
    } else {
      this.options = _.uniqBy(this.options.concat(dropdownOptions), 'value');
    }
  }

  private getDropdownOptions(data: LoadingDropdownData): DropdownItem[] {
    const options: DropdownItem[] = data.values.map(item => new DropdownItem(item.value, item.key, item.title));

    return options;
  }

  private addSelectedItem(dropdownOptions: DropdownItem[], parentItem: { key: string; value: string; title: string }): DropdownItem[] {
    const parentItemDropDownItem = new DropdownItem(parentItem.value, parentItem.key, parentItem.title);

    return [parentItemDropDownItem, ...dropdownOptions];
  }

  public requestLoadItems(settings: LoadingDropdownSettings) {
    this.loading = true;
    this.loadItemsRequest.next(settings);
  }
}
